import React from 'react';
import { ServerPlpData } from 'src/@types/window-extended';

const MultiCollectionToggle = () => {
  const serverPlpData: ServerPlpData | undefined = window.server_plp_data;
  const currentHandle = serverPlpData?.handle || '';
  const multiCollectionConfig = AllMultiCollectionsConfig.find((config) =>
    config.some((item) => item.handle === currentHandle)
  );
  if (!multiCollectionConfig) return null;
  return (
    <div className="MultiCollectionToggle">
      {multiCollectionConfig.map(({ handle, text }) => (
        <a
          key={handle}
          href={`/collections/${handle}`}
          className={`h6 uppercase grey ${currentHandle === handle ? 'active' : ''}`}
        >
          {text}
        </a>
      ))}
    </div>
  );
};

const AllMultiCollectionsConfig = [
  [
    { handle: 'new-arrivals', text: 'Women' },
    { handle: 'mens-new-arrivals', text: 'Men' },
  ],
  [
    { handle: 'womens-sale-all', text: 'Women' },
    { handle: 'mens-sale', text: 'Men' },
  ],
];

export default MultiCollectionToggle;
